window.__patpatapi = 'https://www.patpat.com/shopify-api'
// window.__patpatapi = 'https://shopify-api.patpat.com'

/**
 * 全局 API 请求封装函数
 * 统一处理 API 请求，包括 headers、错误处理等
 * 
 * 使用示例：
 * // GET 请求
 * window.apiRequest.get('/v2/users/profile')
 *   .then(data => console.log(data));
 * 
 * // POST 请求 (JSON)
 * window.apiRequest.post('/v2/users/login', {
 *   email: 'user@example.com',
 *   password: 'password123'
 * }).then(data => console.log(data));
 * 
 * // POST 请求 (FormData)
 * const formData = new FormData();
 * formData.append('file', file);
 * window.apiRequest.post('/v2/upload', formData)
 *   .then(data => console.log(data));
 * 
 * // 自定义 headers
 * window.apiRequest.post('/v2/users/register', userData, {
 *   headers: {
 *     'Custom-Header': 'value'
 *   }
 * }).then(data => console.log(data));
 */
window.apiRequest = function(url, options = {}) {
  const isPc = window.innerWidth > 767;
  // 默认配置
  const defaultOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'unique-session-id': g_getCookie('pp105ut'),
      'patpat-platform': isPc ? 'web' : 'wap',
      'pp-country': window.Shopify.country,
      'pp-language': (window.Shopify.locale || '').toLocaleUpperCase()
    }
  };
  if(window.domain == 'b2ccdd-e0.myshopify.com') {
    console.log('**************** in debug ********************')
    defaultOptions.headers['pp-dbg'] = 1
  }

  const appInfo = window.getAppInfo && window.getAppInfo()
  const usrToken = getPatToken() || (appInfo && appInfo.token)
  if(usrToken) {
    defaultOptions.headers.token = usrToken
  }
  
  if(appInfo && appInfo.language && appInfo.platform != 'wap') {
    defaultOptions.headers.abb = appInfo.language
    // defaultOptions.headers['patpat-platform'] = appInfo.isIos ? 'ios' : 'android'
  }

  if (appInfo && appInfo.deviceID) {
    appInfo.deviceID && (defaultOptions.headers.deviceid = appInfo.deviceID)
    appInfo.appVersion && (defaultOptions.headers['pp-version'] = appInfo.appVersion)
    defaultOptions.headers['pp-client'] = appInfo.isIos ? 'ios' : 'android'
  }

  // 合并配置
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers
    }
  };

  // 处理 FormData 的特殊情况
  if (mergedOptions.body instanceof FormData) {
    // 对于 FormData，删除 Content-Type header，让浏览器自动设置
    delete mergedOptions.headers['Content-Type'];
  } else if (['POST', 'PUT', 'PATCH'].includes(mergedOptions.method.toUpperCase()) && 
             mergedOptions.body && 
             typeof mergedOptions.body === 'object') {
    // 如果是 POST/PUT/PATCH 且 body 是对象，自动转换为 JSON
    mergedOptions.body = JSON.stringify(mergedOptions.body);
  }

  // 处理 Content-Type: undefined 的情况
  if (mergedOptions.headers && mergedOptions.headers['Content-Type'] === undefined) {
    delete mergedOptions.headers['Content-Type'];
  }

  // 完整的 URL
  const fullUrl = url.startsWith('http') ? url : window.__patpatapi + url;

  // 返回 Promise
  return fetch(fullUrl, mergedOptions)
    .then(response => {      
      // 尝试解析为 JSON，如果失败则返回原始响应
      const contentType = response.headers.get('content-type');
      if (response && contentType && contentType.includes('application/json')) {
        return response.json();
      }
      return response;
    })
    .catch(error => {
        // 统一错误处理
        console.error('API Request Error:', error);
        throw error;
    });
};

/**
 * 快捷方法
 */
window.apiRequest.get = function(url, data, options = {}) {
    let params = ''
    if(data) {
        params = new URLSearchParams(data);
    }
    return window.apiRequest(url + (params ? '?' + params.toString() : ''), { ...options, method: 'GET' });
};

window.apiRequest.post = function(url, data, options = {}) {
  return window.apiRequest(url, { 
    ...options, 
    method: 'POST', 
    body: data 
  });
};
